import { useState, useEffect, useContext } from "react";
import styles from "./styles.module.css";
import { TAX_PREFERENCES, TAX_REGIONS, STORAGE_KEYS } from "const";
import { Grid, Radio, RadioGroup, FormControlLabel, FormControl } from "@mui/material";
import ShopSettingsService from "services/ShopService";
import ShopContext from "context/ShopContext";
import Loader from "components/utils/Loading";
import ButtonRed from "components/utils/CustomFields/ButtonRed";
import ButtonGray from "components/utils/CustomFields/ButtonGray";
import toast from "react-hot-toast";

function Tax() {
  const { selectedShop, setSelectedShop } = useContext(ShopContext);

  const [taxEnabled, setTaxEnabled] = useState(true);
  const [taxRegion, setTaxRegion] = useState("");
  const [taxPreference, setTaxPreference] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedShop) {
      setTaxRegion(localStorage.getItem(STORAGE_KEYS.TAX_REGION) || "");
      setTaxPreference(localStorage.getItem(STORAGE_KEYS.TAX_PREFERENCE) || "");
      return;
    }

    setTaxEnabled(!!selectedShop.tax_preference);

    setTaxRegion(selectedShop.tax_region || localStorage.getItem(STORAGE_KEYS.TAX_REGION) || "");
    setTaxPreference(selectedShop.tax_preference || localStorage.getItem(STORAGE_KEYS.TAX_PREFERENCE) || "");
  }, [selectedShop]);

  const handleRegionSelect = (region) => {
    if (!taxEnabled) return;
    setTaxRegion(region);
  };

  const handlePreferenceSelect = (preference) => {
    if (!taxEnabled) return;
    setTaxPreference(preference);
  };

  const handleUpdateTax = async () => {
    setLoading(true);
    try {
      const updatedData = {
        tax_region: taxRegion,
        tax_preference: taxPreference,
      };

      localStorage.setItem(STORAGE_KEYS.TAX_REGION, taxRegion);
      localStorage.setItem(STORAGE_KEYS.TAX_PREFERENCE, taxPreference);

      // Update SHOP_PROFILE in localStorage
      const shopProfileStr = localStorage.getItem(STORAGE_KEYS.SHOP_PROFILE);
      if (shopProfileStr) {
        try {
          const shopProfile = JSON.parse(shopProfileStr);
          const updatedProfile = {
            ...shopProfile,
            tax_region: taxRegion,
            tax_preference: taxPreference,
          };
          localStorage.setItem(STORAGE_KEYS.SHOP_PROFILE, JSON.stringify(updatedProfile));
          setSelectedShop(updatedProfile);
        } catch (error) {
          console.error("Error updating shop profile in localStorage", error);
        }
      }

      await ShopSettingsService.updateShopProfile(updatedData);
    } catch (err) {
      console.log(err);
      toast.error("Error updating tax settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <Loader isOpen={loading} />
      <div className={styles.scrollableArea}>
        <Grid className={styles.contetSection}>
          {/* Tax Region */}
          <Grid className={`${styles.sectionWrapper} ${!taxEnabled ? styles.disabled : ""}`}>
            <h3 className={styles.title}>Tax Region</h3>

            <FormControl component="fieldset" disabled={!taxEnabled}>
              <RadioGroup
                value={taxRegion}
                onChange={(e) => handleRegionSelect(e.target.value)}
                sx={{ flexDirection: "row", flexWrap: "wrap", gap: "10px", padding: "10px" }}
              >
                {TAX_REGIONS.map((regionObj) => {
                  const [label, value] = Object.entries(regionObj)[0];

                  return (
                    <FormControlLabel
                      key={value}
                      value={value}
                      className={styles.option}
                      control={
                        <Radio
                          sx={{
                            transform: "scale(1.2)",
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                            "&.Mui-checked": { color: "#e50218" },
                            padding: "0 10px 0 0",
                          }}
                        />
                      }
                      label={label}
                    />
                  );
                })}
              </RadioGroup>
            </FormControl>
          </Grid>
          {/* Tax Preference */}
          <Grid className={`${styles.sectionWrapper} ${!taxEnabled ? styles.disabled : ""}`}>
            <h3 className={styles.title}>Tax Preference</h3>

            <FormControl component="fieldset" disabled={!taxEnabled}>
              <RadioGroup
                value={taxPreference}
                onChange={(e) => handlePreferenceSelect(e.target.value)}
                sx={{ flexDirection: "row", flexWrap: "wrap", gap: "10px", padding: "10px" }}
              >
                {Object.values(TAX_PREFERENCES).map((pref) => (
                  <FormControlLabel
                    key={pref}
                    value={pref}
                    className={styles.option}
                    control={
                      <Radio
                        sx={{
                          transform: "scale(1.2)",
                          "& .MuiSvgIcon-root": {
                            fontSize: 22,
                          },
                          "&.Mui-checked": {
                            color: "#e50218",
                          },
                          padding: "0 10px 0 0",
                        }}
                      />
                    }
                    label={pref}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </div>

      <Grid className={styles.buttonContainer}>
        <ButtonGray className={styles.buttonGray}>Cancel</ButtonGray>
        <ButtonRed className={styles.buttonRed} onClick={handleUpdateTax}>
          Update
        </ButtonRed>
      </Grid>
    </div>
  );
}

export default Tax;
